/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { __assign, __rest } from "tslib";
import React from "react";
import { ICON_SIZE_STANDARD, ICON_SIZE_LARGE } from "../../constants";
import * as Classes from "../../classes";
export var Cross = function (_a) {
    var className = _a.className, color = _a.color, _b = _a.size, size = _b === void 0 ? ICON_SIZE_STANDARD : _b, _c = _a.title, title = _c === void 0 ? "cross" : _c, _d = _a.htmlTitle, htmlTitle = _d === void 0 ? title : _d, _e = _a.tagName, tagName = _e === void 0 ? "span" : _e, htmlProps = __rest(_a, ["className", "color", "size", "title", "htmlTitle", "tagName"]);
    var isLarge = size >= ICON_SIZE_LARGE;
    var pixelGridSize = isLarge ? ICON_SIZE_LARGE : ICON_SIZE_STANDARD;
    var viewBox = "0 0 " + pixelGridSize + " " + pixelGridSize;
    var path = (React.createElement("path", { d: isLarge
            ? "M11.41 10L15.7 14.29C15.89 14.47 16 14.72 16 15C16 15.55 15.55 16 15 16C14.72 16 14.47 15.89 14.29 15.71L10 11.41L5.71 15.71C5.53 15.89 5.28 16 5 16C4.45 16 4 15.55 4 15C4 14.72 4.11 14.47 4.29 14.29L8.59 10L4.3 5.71C4.11 5.53 4 5.28 4 5C4 4.45 4.45 4 5 4C5.28 4 5.53 4.11 5.71 4.29L10 8.59L14.29 4.3C14.47 4.11 14.72 4 15 4C15.55 4 16 4.45 16 5C16 5.28 15.89 5.53 15.71 5.71L11.41 10z"
            : "M9.41 8L12.7 11.29C12.89 11.47 13 11.72 13 12C13 12.55 12.55 13 12 13C11.72 13 11.47 12.89 11.29 12.71L8 9.41L4.71 12.71C4.53 12.89 4.28 13 4 13C3.45 13 3 12.55 3 12C3 11.72 3.11 11.47 3.29 11.29L6.59 8L3.3 4.71C3.11 4.53 3 4.28 3 4C3 3.45 3.45 3 4 3C4.28 3 4.53 3.11 4.71 3.29L8 6.59L11.29 3.3C11.47 3.11 11.72 3 12 3C12.55 3 13 3.45 13 4C13 4.28 12.89 4.53 12.71 4.71L9.41 8z", fillRule: "evenodd" }));
    if (tagName === null) {
        return (React.createElement("svg", __assign({ fill: color, "data-icon": "cross", width: size, height: size, viewBox: viewBox }, htmlProps),
            title && React.createElement("desc", null, title),
            path));
    }
    else {
        return React.createElement(tagName, __assign(__assign({}, htmlProps), { className: className + " " + Classes.ICON, title: htmlTitle }), React.createElement("svg", { fill: color, "data-icon": "cross", width: size, height: size, viewBox: viewBox },
            title && React.createElement("desc", null, title),
            path));
    }
};
export default Cross;
//# sourceMappingURL=cross.js.map